import HistoryElements from '../helper/HistoryElements';


class MoveEvent {
  constructor(x=0, y=0) {
    this.time = new Date();
    this.x = x;
    this.y = y;
    this._points = new HistoryElements(2);
    this.dx = 0;
    this.dy = 0;
    this.vx = 0;
    this.vy = 0;
  }

  static DefaultValues = () => {
    return {
      x: 0,
      y: 0,
      dx: 0,
      dy: 0,
      vx: 0,
      vy: 0,
    };
  }

  toObject = () => {
    return {
      x: this.x,
      y: this.y,
      dx: this.dx,
      dy: this.dy,
      vx: this.vx,
      vy: this.vy,
    };
  }

  addPoint = (x, y) => {
    const time = new Date();
    this._points.push({ x: x, y: y, time: time });
    this.dx = x - this.x;
    this.dy = x - this.y;
    this.calculate();
  }

  calculate = () => {
    let p1 = null;
    let p2 = null;

    if (this._points.size() === 1) {
      p1 = this._points.at(0);
      p2 = { x: this.x, y: this.y, time: this.time };
    } else {
      p1 = this._points.at(0);
      p2 = this._points.at(1);
    }

    const timeDiff = p1.time - p2.time;

    this.vx = ( p1.x - p2.x ) / timeDiff;
    this.vy = ( p1.y - p2.y ) / timeDiff;
  }
};

export default MoveEvent;
